import { render, staticRenderFns } from "./BIconQQ.vue?vue&type=template&id=a924cc4a&"
import script from "./BIconQQ.vue?vue&type=script&lang=js&"
export * from "./BIconQQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports